export const en = {
    'change-success': 'Product edited successfully',
    error: 'An error occurred, please try again'
};
